module.exports = __webpack_public_path__ + "static/Group6000@2x-c0378fdc5e19736deb0000d0501e3691.png";